<template>
  <v-dialog v-model="dialog" persistent max-width="400">
    <v-card>
      <v-layout pa-2 row>
        <v-flex>
          <v-text-field v-model="bookmark.title" :error-messages="errorMessages('title')"
                        label="Title"></v-text-field>
          <v-text-field v-model="bookmark.value" :error-messages="errorMessages('value')"
                        label="Title"></v-text-field>
        </v-flex>
      </v-layout>
      <v-card-actions>
        <v-btn color="success" @click="save" >Save</v-btn>
        <v-spacer></v-spacer>
        <v-btn @click="dialog = false">cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import * as mixins from '@/mixins'

  export default {
    name: 'bookmark-dialog',
    mixins: [mixins.errors],
    data() {
      return {
        dialog: false,
        bookmark: {}
      }
    },
    methods: {
      open(bookmark) {
        this.dialog = true
        this.errors = false
        this.bookmark = Object.assign({}, bookmark)
      },
      save() {
        this.$api.bookmarks.save(this.bookmark).then(() => {
          this.errors = []
          this.dialog = false
          this.$emit('refresh')
        }, response => {
          this.errors = response.errors
        })
      },
    },
    mounted() {
      const self = this

      window.addEventListener('keypress', function (e) {
        if (e.key === 'Enter') {
          self.confirmRemove()
        }
      })
    }
  }
</script>

